import { log } from 'log';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { prop, pick, path } from 'js/utils/ramda.util';
import { useUserSelector, useCustomSelector } from 'js/store/hooks';
import { AUTH_REDUCER, SPORTSBOOK_REDUCER } from 'js/store/constants';

export const useSportsbookSyncSession = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const isAppInitialized = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitialized']));
    const { isLogoutInProcess, isLoginInProcess } = useCustomSelector(AUTH_REDUCER, pick(['isLogoutInProcess', 'isLoginInProcess']));

    useEffect(() => {
        if (!isAppInitialized || isLogoutInProcess || isLoginInProcess) {
            return;
        }

        try {
            window.Sportsbook?.sendMessage('SYNC_SESSION');
        } catch (error) {
            log('log', '[SPORTSBOOK | Portal] sync session error', error);
        }
    }, [isLoggedIn, isLogoutInProcess, isLoginInProcess, isAppInitialized]);
};
